import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import { LayoutModule } from "../layout.module";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { HeaderNavComponent } from "./header-nav.component";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TaskComponent } from "../../../task/task.component";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { NewIssueModalModule } from "../../../shared/components/new-issue-modal/new-issue-modal.module";
// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
    imports: [
        CommonModule,
        // LayoutModule,
        RouterModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgbPopoverModule,
        NewIssueModalModule
    ],
    exports: [HeaderNavComponent, TaskComponent],
    declarations: [HeaderNavComponent, TaskComponent]
})
export class HeaderNavSharedModule { }
